/**
 * Placeholder table templates for the taxpeer editor
 */
export const tablePlaceholderTemplates = {
	rowTemplates: {
		buchungssatz: {
			cells: ["Wirtschaftsgut", "€", "", "Wirtschaftsgut", "€"],
		},
		bilanz: {
			cells: ["...", "€", "", "...", "€"],
		},
		guv: {
			cells: ["...", "€", "", "...", "€"],
		},
		staffel: {
			cells: ["Datum", "€", "€"],
		},
	},
	tableTemplates: {
		buchungssatz: {
			title: "",
			html: `<table class="taxpeer buchungssatz" style="width: 100%; border-collapse: collapse; border-style: none;" border="1">
			<colgroup>
				<col style="width: 35%;">
				<col style="width: 13%;">
				<col style="width: 7%;">
				<col style="width: 26%;">
				<col style="width: 19%;">
			</colgroup>
			<tbody>
				<tr>
					<td style="border-width: 0px;"><p>Wirtschaftsgut</p></td>
					<td style="text-align: right; border-width: 0px;"><p>&euro;</p></td>
					<td style="border-width: 0px;"><p style="text-align: center;">an</p></td>
					<td style="border-width: 0px;"><p>Wirtschaftsgut</p></td>
					<td style="text-align: right; border-width: 0px;"><p>&euro;</p></td>
				</tr>
			</tbody>
		</table>
		<p>&nbsp;</p>`,
		},
		schulden: {
			title: "Schulden gem. § 10 Abs. 6 Satz 5 und 6 ErbStG",
			html: `<table class="taxpeer schulden" style="width: 100%; border-collapse: collapse;" border="1">
		  <tbody>
			<tr>
			  <td style="width: 100%; border: 1px solid black; text-align: center; font-weight: bold;" colspan="2">Schulden gem. § 10 Abs. 6 Satz 5 und 6 ErbStG</td>
			</tr>
			<tr>
			  <td style="width: 80%; border: 1px solid black; font-weight: bold;">Bezeichnung / kurze Begründung</td>
			  <td style="width: 20%; border: 1px solid black; text-align: center; font-weight: bold;">Betrag</td>
			</tr>
			<tr>
			  <td style="border: 1px solid black;">&nbsp;</td>
			  <td style= border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			  <td style="border: 1px solid black;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			  <td style="border: 1px solid black;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			  <td style="border: 1px solid black;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			  <td style="border: 1px solid black; font-weight: bold;">Summe</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
		  </tbody>
		</table>
		<p>&nbsp;</p>`,
		},
		aufteilung: {
			title: "Aufteilung gem. § 10 Abs. 6 Satz 7 und 8 ErbStG",
			html: `<table class="taxpeer aufteilung" style="width: 100%; border-collapse: collapse;" border="1">
		  <tbody>
			<tr>
			  <td style="width: 100%; border: 1px solid black; text-align: center; font-weight: bold;" colspan="5">Aufteilung gem. § 10 Abs. 6 Satz 7 und 8 ErbStG</td>
			</tr>
			<tr>
			  <td style="width: 40%; border: 1px solid black; font-weight: bold;">Vermögensgegenstand</td>
			  <td style="width: 15%; border: 1px solid black; font-weight: bold;">"Bruttowert"</td>
			  <td style="width: 15%; border: 1px solid black; font-weight: bold;">./. Schulden</td>
			  <td style="width: 15%; border: 1px solid black; font-weight: bold;">"Nettowert"</td>
			  <td style="width: 15%; border: 1px solid black; font-weight: bold;">Anteil in %</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			  <td style="border: 1px solid black; font-weight: bold;">Summe</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
		  </tbody>
		</table>
		<p>&nbsp;</p>`,
		},
		schuldenabzug: {
			title: "Schuldenabzug gem. § 10 Abs. 6 Satz 9 und 10 ErbStG",
			html: `<table class="taxpeer schuldenabzug" style="width: 100%; border-collapse: collapse;" border="1">
		  <tbody>
			<tr>
			  <td style="width: 100%; border: 1px solid black; text-align: center; font-weight: bold;" colspan="7">Schuldenabzug gem. § 10 Abs. 6 Satz 9 und 10 ErbStG</td>
			</tr>
			<tr>
			  <td style="width: 25%; border: 1px solid black; font-weight: bold;">Vermögensgegenstand</td>
			  <td style="width: 12.5%; border: 1px solid black; font-weight: bold;">Summe<br>Schulden</td>
			  <td style="width: 12.5%; border: 1px solid black; font-weight: bold;">Anteil<br>%</td>
			  <td style="width: 12.5%; border: 1px solid black; font-weight: bold;">Anteilige<br>Schulden</td>
			  <td style="width: 12.5%; border: 1px solid black; font-weight: bold;">Wert nach<br>Steuerbefreiung</td>
			  <td style="width: 12.5%; border: 1px solid black; font-weight: bold;">Wert vor<br>Steuerbefreiung</td>
			  <td style="width: 12.5%; border: 1px solid black; font-weight: bold;">Abziehbare<br>Schulden</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			  <td style="border: 1px solid black; font-weight: bold;">Summe</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
		  </tbody>
		</table>
		<p>&nbsp;</p>`,
		},
		zusammenfassung: {
			title: "Zusammenfassung für zwei Personen",
			html: `<table class="taxpeer zusammenfassung" style="width: 100%; border-collapse: collapse;" border="1">
		  <tbody>
			<tr>
			  <td style="width: 100%; border: 1px solid black; text-align: center; font-weight: bold;" colspan="3">Zusammenfassung für zwei Personen</td>
			</tr>
			<tr>
			  <td style="width: 70%; border: 1px solid black;">&nbsp;</td>
			  <td style="width: 15%; border: 1px solid black; text-align: center; font-weight: bold;">Person 1</td>
			  <td style="width: 15%; border: 1px solid black; text-align: center; font-weight: bold;">Person 2</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			<td style="border: 1px solid black;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
			<tr>
			  <td style="border: 1px solid black;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			  <td style="border: 1px solid black; text-align: right;">&nbsp;</td>
			</tr>
		  </tbody>
		</table>
		<p>&nbsp;</p>`,
		},
		bilanz: {
			title: "",
			html: `<table class="taxpeer bilanz" style="width: 100%; height: 147px; border-collapse: collapse; border-style: hidden;" border="1">
			<tbody>
				<tr>
					<td style="width: 100%; border-width: medium medium 1pt; border-style: none none solid; border-color: black;" colspan="5" valign="top">
						<p style="text-align: center;"><strong>Bilanz von XXX zum TT.MM.JJJJ</strong></p>
					</td>
				</tr>
				<tr>
					<td style="width: 19%; border: medium; padding: 3px;">
						<span>Posten</span>
					</td>
					<td style="width: 20%; border: medium; padding: 3px; text-align: right;">
						<span>&nbsp;&euro;</span>
					</td>
					<td style="width: 1%; border-width: medium 1pt medium medium; border-style: none solid none none; border-color: black; padding: 3px;">
						<span>&nbsp;</span>
					</td>
					<td style="width: 30%; border: medium; padding: 3px;">
						<span>Posten</span>
					</td>
					<td style="width: 22%; border: medium; padding: 3px; text-align: right;">
						<span>&nbsp;&euro;</span>
					</td>
				</tr>
				<tr>
					<td style="border: medium; padding: 3px;">
						<span>...</span>
					</td>
					<td style="border: medium; padding: 3px; text-align: right;">
						<span>&nbsp;&euro;</span>
					</td>
					<td style="border-width: medium 1pt medium medium; border-style: none solid none none; border-color: black; padding: 3px;">
						<span>&nbsp;</span>
					</td>
					<td style="border: medium; padding: 3px;">
						<span>...</span>
					</td>
					<td style="border: medium; padding: 3px; text-align: right;">
						<span>&euro;</span>
					</td>
				</tr>
				<tr>
					<td style="border: medium; padding: 3px;">
						<span>...</span>
					</td>
					<td style="border: medium; padding: 3px; text-align: right;">
						<span>&nbsp;&euro;</span>
					</td>
					<td style="border-width: medium 1pt medium medium; border-style: none solid none none; border-color: black; padding: 3px;">
						<span>&nbsp;</span>
					</td>
					<td style="border: medium; padding: 3px;">
						<span>...</span>
					</td>
					<td style="border: medium; padding: 3px; text-align: right;">
						<span>&euro;</span>
					</td>
				</tr>
				<tr style="height: 25px; border-color: rgb(0, 0, 0); border-style: solid;">
					<td style="border-width: 2pt 0 0 0; border-style: solid none none none; border-color: black; padding: 3px;">&nbsp;</td>
					<td style="border-width: 2pt 0 0 0; border-style: solid none none none; border-color: black; padding: 3px; text-align: right;"><strong>&nbsp;&euro;</strong></td>
					<td style="border-width: 2pt 1pt 0 0; border-style: solid solid none none; border-color: black; padding: 3px; text-align: right;">&nbsp;</td>
					<td style="border-width: 2pt 0 0 0; border-style: solid none none none; border-color: black; padding: 3px;">&nbsp;</td>
					<td style="border-width: 2pt 0 0 0; border-style: solid none none none; border-color: black; padding: 3px; text-align: right;"><strong>&nbsp;&euro;</strong></td>
				</tr>
			</tbody>
		</table>
		<p>&nbsp;</p>`,
		},
		guv: {
			title: "GuV JJJJ",
			html: `<table class="taxpeer guv" style="width: 100%; height: 147px; border-collapse: collapse; border-style: hidden;" border="1">
			<tbody>
				<tr>
					<td style="width: 100%; border-width: medium medium 1pt; border-style: none none solid; border-color: black;" colspan="5" valign="top">
						<p style="text-align: center;"><strong>GuV JJJJ</strong></p>
					</td>
				</tr>
				<tr>
					<td style="width: 27%; border: medium; padding: 3px;">
						<span>Aufwendungen</span>
					</td>
					<td style="width: 20%; border: medium; padding: 3px; text-align: right;">
						<span>&nbsp;&euro;</span>
					</td>
					<td style="width: 1%; border-width: medium 1pt medium medium; border-style: none solid none none; border-color: black; padding: 3px;">
						<span>&nbsp;</span>
					</td>
					<td style="width: 30%; border: medium; padding: 3px;">
						<span>Erträge</span>
					</td>
					<td style="width: 22%; border: medium; padding: 3px; text-align: right;">
						<span>&nbsp;&euro;</span>
					</td>
				</tr>
				<tr>
					<td style="border: medium; padding: 3px;">
						<span>...</span>
					</td>
					<td style="border: medium; padding: 3px; text-align: right;">
						<span>&nbsp;&euro;</span>
					</td>
					<td style="border-width: medium 1pt medium medium; border-style: none solid none none; border-color: black; padding: 3px;">
						<span>&nbsp;</span>
					</td>
					<td style="border: medium; padding: 3px;">
						<span>...</span>
					</td>
					<td style="border: medium; padding: 3px; text-align: right;">
						<span>&euro;</span>
					</td>
				</tr>
				<tr>
					<td style="border: medium; padding: 3px;">
						<span>...</span>
					</td>
					<td style="border: medium; padding: 3px; text-align: right;">
						<span>&nbsp;&euro;</span>
					</td>
					<td style="border-width: medium 1pt medium medium; border-style: none solid none none; border-color: black; padding: 3px;">
						<span>&nbsp;</span>
					</td>
					<td style="border: medium; padding: 3px;">
						<span>...</span>
					</td>
					<td style="border: medium; padding: 3px; text-align: right;">
						<span>&euro;</span>
					</td>
				</tr>
				<tr style="height: 25px; border-color: rgb(0, 0, 0); border-style: solid;">
					<td style="border-width: 2pt 0 0 0; border-style: solid none none none; border-color: black; padding: 3px;">&nbsp;</td>
					<td style="border-width: 2pt 0 0 0; border-style: solid none none none; border-color: black; padding: 3px; text-align: right;"><strong>&nbsp;&euro;</strong></td>
					<td style="border-width: 2pt 1pt 0 0; border-style: solid solid none none; border-color: black; padding: 3px; text-align: right;">&nbsp;</td>
					<td style="border-width: 2pt 0 0 0; border-style: solid none none none; border-color: black; padding: 3px;">&nbsp;</td>
					<td style="border-width: 2pt 0 0 0; border-style: solid none none none; border-color: black; padding: 3px; text-align: right;"><strong>&nbsp;&euro;</strong></td>
				</tr>
			</tbody>
		</table>
		<p>&nbsp;</p>`,
		},
		staffel: {
			title: "Abstimmung HB/StB",
			html: `<table class="taxpeer staffel" style="width: 100%; border-collapse: collapse;" border="1">
			<tbody>
				<tr>
					<td style="width: 40%; border: 1px solid black; font-weight: bold;">Wirtschaftsgut</td>
					<td style="width: 30%; border: 1px solid black; text-align: center; font-weight: bold;">HB</td>
					<td style="width: 30%; border: 1px solid black; text-align: center; font-weight: bold;">StB</td>
				</tr>
				<tr>
					<td style="border: 1px solid black;">&nbsp;</td>
					<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
					<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
				</tr>
				<tr>
					<td style="border: 1px solid black;">&nbsp;</td>
					<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
					<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
				</tr>
				<tr>
					<td style="border: 1px solid black;">&nbsp;</td>
					<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
					<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
				</tr>
				<tr>
					<td style="border: 1px solid black; font-weight: bold;">Summe</td>
					<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
					<td style="border: 1px solid black; text-align: right;">&nbsp;</td>
				</tr>
			</tbody>
		</table>
		<p>&nbsp;</p>`,
		},
	},
};
